import React, { useState, useEffect } from "react";
import { Row, Col, Card, Skeleton, Divider, Empty } from "antd";
import { Link } from "react-router-dom";
import { gql, useLazyQuery } from "@apollo/client";
import { apiUrl } from "@utils/apoloClient";
import StrikethroughPrice from "@general/strikethroughPrice";
import OtherErrors from "@general/otherErrors";

const UserEvents = ({ colSpan }) => {
  const [eventsDetails, setEventsDtails] = useState([]);
  const cardColSpan = colSpan || { xl: 6, lg: 8, sm: 12, xs: 24 };

  const GETEVENTS = gql`
    query ($paginateInput: PaginateInput!, $searchInput: ProductSearchInput!) {
      getProducts(paginateInput: $paginateInput, searchInput: $searchInput) {
        id
        name
        image
        capacity
        amountRial
        strikethroughRial
      }
    }
  `;
  const [getEvents, events] = useLazyQuery(GETEVENTS, {
    fetchPolicy: "no-cache",
    onCompleted(data) {
      setEventsDtails(data?.getProducts);
    },
    onError(err) {
      console.log("Error while fetching Events: ", err);
    },
  });

  useEffect(() => {
    getEvents({
      variables: {
        paginateInput: {
          page: 1,
          perPage: 100,
        },
        searchInput: {
          category: ["EVENT"],
        },
      },
    });
  }, []);

  const style = {
    card: {
      width: 240,
      minHeight: 320,
      display: "block",
      margin: "auto",
    },
    title: {
      fontWeight: "bold",
      textAlign: "center",
      fontSize: "15px",
    },
  };

  if (events.loading) {
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  }

  if (events.error) {
    return <OtherErrors />;
  }

  if (eventsDetails?.length) {
    return (
      <Row
        gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 50]}
        align="middle"
      >
        <Divider
          orientation="right"
          style={{ fontSize: "15px", fontWeight: "bold" }}
        >
          رویدادها
        </Divider>
        {eventsDetails?.map((event) => {
          return (
            <Col key={event?.id} {...cardColSpan}>
              <Link to={`/events/events-single/${event?.id}`}>
                <Card
                  hoverable
                  style={style.card}
                  cover={<img alt="safatec" src={`${apiUrl + event?.image}`} />}
                >
                  <p style={style.title}>{event?.name}</p>
                  <span className="card-row">
                    <p>ظرفیت: </p> <span>{`${event?.capacity} نفر`}</span>
                  </span>
                  <StrikethroughPrice
                    strikethroughRial={event?.strikethroughRial}
                    amountRial={event?.amountRial}
                  />
                </Card>
              </Link>
            </Col>
          );
        })}
      </Row>
    );
  }

  return (
    <div>
      <Divider
        orientation="right"
        style={{ fontSize: "15px", fontWeight: "bold" }}
      >
        رویدادها
      </Divider>
      <Empty description="در حال حاضر رویداد فعالی موجود نیست!" />
    </div>
  );
};

export default UserEvents;
